import app from '../app';

/**
 * Fire a Flarum error which is shown in the JS console for everyone and in an alert for the admin.
 *
 * @param userTitle a user friendly title of the error, should be localized.
 * @param consoleTitle an error title that goes in the console, doesn't have to be localized.
 * @param error the error.
 */
export default function fireApplicationError(userTitle, consoleTitle, error) {
  var _app$session;
  console.group("%c".concat(consoleTitle), 'background-color: #d83e3e; color: #ffffff; font-weight: bold;');
  console.error(error);
  console.groupEnd();
  if ((_app$session = app.session) != null && (_app$session = _app$session.user) != null && _app$session.isAdmin()) {
    app.alerts.show({
      type: 'error'
    }, "".concat(userTitle));
  }
}
flarum.reg.add('core', 'common/helpers/fireApplicationError', fireApplicationError);